<template>
    <section class="project-grid">
      <h2 class="grid-title">Meus Projetos</h2>
      <div class="grid-container">
        <div 
          v-for="(projeto, index) in projetos" 
          :key="index" 
          class="grid-card"
        >
          <h3 class="card-title">{{ projeto.title }}</h3>
          <p class="card-description">{{ projeto.description }}</p>
          <span class="card-date">{{ formatDate(projeto.date) }}</span>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import projetosData from "@/data/projetos.json";
  
  export default {
    name: "ProjectGrid",
    data() {
      return {
        projetos: projetosData.projetos.reverse() // Reverte para popular da direita para a esquerda
      };
    },
    methods: {
      formatDate(date) {
        const options = { year: "numeric", month: "long" };
        return new Date(date).toLocaleDateString("pt-BR", options);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Estilo Geral */
  .project-grid {
    padding: 32px;
    font-family: "Helvetica Nos Micro Regular", sans-serif;
  }
  
  .grid-title {
    font-family: "Europa Grotesk SH Med", sans-serif;
    font-size: 2rem;
    color: #222;
    margin-bottom: 20px;
    text-align: start;
  }
  
  /* Estilo do Container Grid */
  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
    direction: rtl; /* Popula da direita para a esquerda */
  }
  
  /* Estilo dos Cards */
  .grid-card {
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .grid-card:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }

  /* Estilo do Título do Card */
  .card-title {
    font-family: "Europa Grotesk SH Med", sans-serif;
    font-size: 1.25rem;
    color: #222;
    margin-bottom: 8px;
    font-weight: bold;
    font-family: "Helvetica Nos Micro Regular", sans-serif;
  }
  
  /* Estilo da Descrição do Card */
  .card-description {
    font-size: 1rem;
    color: #555;
    line-height: 1.6;
    margin-bottom: 12px;
    font-family: "Helvetica Nos Micro Regular", sans-serif;
  }
  
  /* Estilo da Data do Card */
  .card-date {
    font-size: 0.875rem;
    color: #999;
    font-style: italic;
  }
  
  /* Responsividade */
  @media (max-width: 768px) {
    .grid-container {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  
    .grid-card {
      padding: 16px;
    }
  
    .card-title {
      font-size: 1.125rem;
    }
  
    .card-description {
      font-size: 0.9rem;
    }
  }
  </style>
  